import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Bar, Cell } from "recharts";
import { CustomTooltip } from "./CustomTooltip";
import { MONTHS_ES, MONTHS_FULL_ES } from "../constants";

export const MonthlyComparison = ({ monthlyData }) => {
  if (!monthlyData || !monthlyData.months || monthlyData.months.length === 0) {
    return (
      <div className="bg-[#0d0d0f] rounded-xl border border-gray-800 p-6">
        <h3 className="text-lg font-semibold text-white mb-4">Comparativa Mensual</h3>
        <p className="text-gray-500">No hay datos de múltiples meses disponibles</p>
      </div>
    );
  }

  const formatMonth = (monthStr) => {
    const [year, month] = monthStr.split('-');
    return `${MONTHS_FULL_ES[parseInt(month) - 1]} ${year}`;
  };

  return (
    <div className="bg-[#0d0d0f] rounded-xl border border-gray-800 p-6">
      <h3 className="text-lg font-semibold text-white mb-4">Comparativa Mensual</h3>
      <div className="h-64 mb-6">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={monthlyData.months}>
            <CartesianGrid strokeDasharray="3 3" stroke="#1f1f23" />
            <XAxis dataKey="month" stroke="#6b7280" tick={{ fill: '#6b7280', fontSize: 11 }} tickFormatter={(v) => MONTHS_ES[parseInt(v.split('-')[1]) - 1]} />
            <YAxis stroke="#6b7280" tick={{ fill: '#6b7280', fontSize: 11 }} />
            <Tooltip content={<CustomTooltip />} />
            <Bar dataKey="total_pnl" name="PNL Mensual">
              {monthlyData.months.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.total_pnl >= 0 ? '#10b981' : '#ef4444'} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-800">
              <th className="text-left py-3 text-gray-400 font-medium">Mes</th>
              <th className="text-right py-3 text-gray-400 font-medium">PNL</th>
              <th className="text-right py-3 text-gray-400 font-medium">Trades</th>
              <th className="text-right py-3 text-gray-400 font-medium">Win Rate</th>
              <th className="text-right py-3 text-gray-400 font-medium">Promedio/día</th>
            </tr>
          </thead>
          <tbody>
            {monthlyData.months.map((month) => (
              <tr key={month.month} className="border-b border-gray-800/50">
                <td className="py-3 text-white font-medium">{formatMonth(month.month)}</td>
                <td className={`py-3 text-right font-semibold ${month.total_pnl >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>
                  {month.total_pnl >= 0 ? '+' : ''}{month.total_pnl.toFixed(2)} USDT
                </td>
                <td className="py-3 text-right text-gray-300">{month.trades}</td>
                <td className="py-3 text-right text-gray-300">{month.win_rate}%</td>
                <td className={`py-3 text-right ${month.avg_daily_pnl >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>
                  {month.avg_daily_pnl >= 0 ? '+' : ''}{month.avg_daily_pnl.toFixed(2)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
